module.exports = __webpack_public_path__ + "img/thermometer.e63cb0d2.svg";